import merge from 'lodash/merge.js';

import RoleModel from '@/models/Role.js';
import axios from '@/plugins/axios.js';
import Role from '@/store/modules/roles/Role.js';
import Collection from '@/store/quill/Collection.js';
import { promiseError, toggleLoading } from '@/store/utilities/Helpers.js';
import QueryString from '@/store/utilities/QueryCollection.js';

export default merge(Collection('Roles', Role), {
    state: {
        sort: {
            name: 'asc',
            created_at: 'asc',
        },
        filter: {},
    },

    getters: {
        ...QueryString,
    },

    actions: {
        async fetch(context) {
            toggleLoading(context);

            try {
                const { data } = await axios.get('/api/roles');

                toggleLoading(context);

                context.dispatch('hydrate', data.data);

                return data.data;
            } catch (error) {
                toggleLoading(context);

                promiseError({
                    key: 'roles_load_error',
                    context,
                });

                return error;
            }
        },

        async fetchAssignable(context, model) {
            toggleLoading(context);

            if (!model) {
                throw new Error('Model must be set to fetch assignable roles');
            }

            try {
                const url = `/api/assignable-roles?model=${model}`;

                const { data } = await axios.get(url);

                toggleLoading(context);

                await context.dispatch('hydrate', data.data);

                await RoleModel.insert({ data: data.data });

                return data.data;
            } catch (error) {
                toggleLoading(context);

                promiseError({
                    key: 'assignable_roles_load_error',
                    context,
                });

                return error;
            }
        },
    },
});
